<template>
  <div class="base-lb">
    <div></div>
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
  @keyframes loadingBar {
    0% {
      transform-origin: left;
      transform: scaleX(0);
    } 50% {
      transform-origin: left;
      transform: scaleX(1);
    } 51% {
      transform-origin: right;
      transform: scaleX(1);
    } 100% {
      transform-origin: right;
      transform: scaleX(0);
    }
  }

  .base-lb {
    display: flex;
    border-radius: 2px;
    overflow: hidden;
    width: 300px;
    height: 5px;
    background: lighten($light-grey, 2%);

    div {
      display: flex;
      background: $main-blue;
      width: 100%;
      height: 100%;
      border-radius: 2px;
      transition: 0.25s transform;
      animation: loadingBar 2s infinite;
    }
  }
</style>